import { render, staticRenderFns } from "./cebsbInfo_community_detail.vue?vue&type=template&id=05c21c18&scoped=true&"
import script from "./cebsbInfo_community_detail.vue?vue&type=script&lang=js&"
export * from "./cebsbInfo_community_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c21c18",
  null
  
)

export default component.exports